import { render, staticRenderFns } from "./EditDeposit.vue?vue&type=template&id=7ed56bd6&scoped=true&"
import script from "./EditDeposit.vue?vue&type=script&lang=js&"
export * from "./EditDeposit.vue?vue&type=script&lang=js&"
import style0 from "./EditDeposit.vue?vue&type=style&index=0&id=7ed56bd6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed56bd6",
  null
  
)

export default component.exports